const $ = require("jquery");
//const carroucel = require('../../../components/carousel/carousel.script');
const rellax = require('../../../components/rellax/rellax.script');
//const main_banner = require('../../../components/main_banner/main_banner.script');
const AOS_animation = require('../../../components/AOS-animation/AOS-animation.script');
const FV = require('../../../components/form-validation/form-validation.script');
const barba = require('@barba/core').default
const onboardingService = require("../../../../services/onboard")
const donorsService = require("../../../../services/donors")


export async function load() {
    try {

        if($('#selOng').prop("checked")){
            changeForm('CNPJ');
            $('h2').text('Digite o CNPJ de sua ONG para continuar');
        };

        await rellax.start('.rellax');
        await AOS_animation.start();
        const formEl = document.getElementById('etapa_1');
        await startForm(formEl)
        await FV
            .addMasksToView(formEl)
        //await changeForm('CNPJ');

        await checkParams()
        return true
    } catch (err) {
        console.log('err', err)
        return err
    }
}

async function startForm(formEl) {
    document.getElementsByName("selTipo")
        .forEach((selTipoEl) => {
            selTipoEl.addEventListener('click', (e) => {
                changeForm(selTipoEl.getAttribute('formType'))
            });
        });

    formEl.addEventListener('submit', function(evt) {
        evt.preventDefault()
        FV.clearErrosMessages(formEl)
        sendForm(formEl)
    })
}

async function checkParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const queroDoar = urlParams.get('queroDoar');
    const precisoDestesItens = urlParams.get('precisoDestesItens');

    if (queroDoar) {
        try {
            const profile = await donorsService.getProfile(queroDoar)
            console.log('profile', profile)
            localStorage.setItem('queroDoar', `{"id":"${profile.data.id}","title":"${profile.data.ong_entities.name}"}`)
        } catch (err) {
            console.log('err ->', err)
        }

    } else if (precisoDestesItens) {
        try {
            const profile = await donorsService.getProfile(precisoDestesItens)
    
            let entityName = '';

            if (profile.data.type === 'pj') {
                entityName = profile.data.pj_entities.name;
            } else if (profile.data.type === 'ong') {
                entityName = profile.data.ong_entities.name;
            } else if (profile.data.type === 'pf') {
                entityName = profile.data.responsable_name;
            }

            localStorage.setItem('precisoDestesItens', `{"id":"${profile.data.id}","title":"${entityName}"}`)

        } catch (err) {
            console.log('err ->', err)
        }
    } else if (queroReceber) {
        try {
            const profile = await donorsService.getProfile(queroReceber)
            console.log('profile', profile)
            localStorage.setItem('queroReceber', true)
        } catch (err) {
            console.log('err ->', err)
        }

    }
}

async function sendForm(formEL) {

    if (FV.thisFormIsValid(formEL)) {

        const button = document.getElementById('send-button');
        if (!button.classList.contains('loading')) {
            button.classList.add('loading');
        }

        try {
            const formValues = await FV.getFormValues(formEL);

            // check if there is an user wish this document

            const bodyObject = {
                selTipo: formValues.selTipo,
                document: (formValues.CPF || formValues.CNPJ)
            }

            var response = await onboardingService.onboard(bodyObject)

            if (response.status && response.status == 404) {
                response = await response.json();
              
                if(bodyObject.selTipo == "ongreceivedonation") {
                    // Doações provenientes da rota /doador-ficha/XXXX e com clique no botão "Preciso destes itens"
                    const url = `/cadastro/etapa_3_1/${response.data.hash}`
                    window.barba.go(`${url}`);
                } else {
                    window.barba.go(`/cadastro/etapa_2?selTipo=${bodyObject.selTipo}&document=${bodyObject.document}`);
                }
            } else {
                response = await response.json()
                console.log('response',response)
                if (response.data.verified == 'yes') {
                    const url = `/cadastro/etapa_3/${response.data.hash}`
                    window.barba.go(`${url}`);
                } else {
                    const url = `/cadastro/etapa_7/${response.data.hash}`
                    window.barba.go(`${url}`);
                }

            }

            if (button.classList.contains('loading')) {
                button.classList.remove('loading');
            }

        } catch (err) {
            if (button.classList.contains('loading')) {
                button.classList.remove('loading');
            }
            console.log('err', err)
        }

    }


}

async function changeForm(type) {
    const inputBoxContainerEL = document.getElementById("inputBoxContainer");
    
    const formHTML = {
        CNPJ: `<inputBox field="CNPJ" type="CNPJ" inputType="text" isRequired="true">
            <div class="label-float">
                <input placeholder="CNPJ da sua instituição" id="doc" type="text" value="" name="CNPJ">
                <label>CNPJ da sua instituição</label>
                <errorMessage>Este campo é obrigatório para prosseguir</errorMessage>
            </div>
        </inputBox>`,
        CPF: `<inputBox field="CPF" type="CPF" inputType="text" isRequired="true">
            <div class="label-float">
                <input placeholder="Seu CPF" id="doc" type="text" value=""  name="CPF">
                <label>Seu CPF</label>
                <errorMessage>Este campo é obrigatório para prosseguir</errorMessage>
            </div>
        </inputBox>`
    }

    inputBoxContainerEL.innerHTML = formHTML[type]
    
    $('#send-button').addClass('disabled');
    $('#doc').keyup(function(){
        var valor = $(this).val();
        if(valor != ""){
            $('#send-button').removeClass('disabled');
        }else{
            $('#send-button').addClass('disabled');
        }
    });

    const formEl = document
        .getElementById('etapa_1')
    await startForm(formEl)
    await FV
        .addMasksToView(formEl)
}
